import { render, staticRenderFns } from "./row.vue?vue&type=template&id=f128417c&"
import script from "./row.vue?vue&type=script&lang=js&"
export * from "./row.vue?vue&type=script&lang=js&"
import style0 from "./row.vue?vue&type=style&index=0&id=f128417c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzAirlineIcon: require('/opt/airport.kg/node_modules/razlet-ui/src/components/airline-icon/index.vue').default,TabloStatusBadge: require('/opt/airport.kg/src/components/tablo/status-badge.vue').default})
